module.exports = __webpack_public_path__ + "static/media/gq.c095a0d4.svg";